import fetch from '../../fetch';


const deleteFile = (dataList) => {
    const ids = dataList.map(d => d.id);
    return fetch.post('second/credit/import/temp/file/delete', ids);
}

const query = (itemId) => {
    return fetch.get('second/credit/import/temp/file/query/' + itemId);
}

export default {
    upload: `${fetch.base}second/credit/import/temp/file/upload/`,
    deleteFile,
    query
}